// Real Google Business Profile figures. Refresh monthly with `gcp_query.py gbp-status Frayze`
// (alongside projects/frayze-ca/AI-ANSWER-CHECK.md); never hand-edit upward.
const reviews = {
  rating: 5.0,
  count: 12,
  checked: "2026-10-03",
  source: "Frayze Technologies Inc. Google Business Profile, read live via the Places API on 2026-10-03: 5 stars, 12 reviews",
  url: "https://maps.app.goo.gl/83g7Ew9PjxcsJQkMA",
};

/**
 * Real Google Business Profile rating, linked to the live listing.
 * Figures and their source live in `reviews` above. Never a default or invented value (proof-integrity).
 */
export function GoogleReviewsBadge({ tone = "light", className = "" }: { tone?: "light" | "dark"; className?: string }) {
  const text = tone === "dark" ? "text-white/90 hover:text-white" : "text-[#5A6270] hover:text-[#101319]";
  const star = tone === "dark" ? "#FFFFFF" : "#F5A524";
  return (
    <a
      href={reviews.url}
      target="_blank"
      rel="noopener noreferrer"
      className={`inline-flex items-center gap-2 text-sm font-medium transition-colors ${text} ${className}`}
      aria-label={`Rated ${reviews.rating.toFixed(1)} out of 5 from ${reviews.count} Google reviews`}
    >
      <span className="inline-flex" aria-hidden="true">
        {Array.from({ length: 5 }).map((_, i) => (
          <svg key={i} viewBox="0 0 20 20" className="w-4 h-4" fill={star}>
            <path d="M10 1.5l2.6 5.3 5.9.9-4.3 4.1 1 5.8L10 14.9l-5.2 2.7 1-5.8L1.5 7.7l5.9-.9L10 1.5z" />
          </svg>
        ))}
      </span>
      <span>
        {reviews.rating.toFixed(1)} on Google · {reviews.count} reviews
      </span>
    </a>
  );
}
